<template>
  <div style="margin-bottom: 16px;" id="custom_social-form-group" class="alt-form-group multiple_checkbox2-form-group form-group">
    <label style="margin-bottom: 5px;" for="custom_social">{{ title }} <span class="required">*</span></label>
    <div class="multiple-checkbox-form-group pt_custom_filed">
      <div v-for="(social, index) in socialOptions" :key="index" class="checkbox-form-group-wrapper">
        <input
          type="checkbox"
          :id="`custom_social_` + social?.id"
          class="form-control custom-checkbox"
          :data-value="social.label"
          name="custom_social[]"
          v-model="selectedSocials[index].checked"
          @change="toggleInputField({
            key: props.type,
            value: social.key,
            type: social.key,
            label: social.label
          }, index)"
        />
        <svg style="margin-top:1px">
          <use xlink:href="#checkmark-custom_social"></use>
        </svg>
        <label style="font-size: 14px; color: #212529; text-transform: none; display: inline-block; margin-top: 3px;" 
               :for="'custom_social_' + social?.id">
          {{ social.label }}
        </label>
        <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
          <symbol id="checkmark-custom_social" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-miterlimit="10" fill="none" d="M22.9 3.7l-15.2 16.6-6.6-7.1"></path>
          </symbol>
        </svg>

        <!-- Sử dụng v-if để hiển thị ô input khi checkbox được chọn -->
        <input
          v-if="selectedSocials[index].checked && social.isShowInput === 1"
          type="text"
          class="form-control"
          style="margin-bottom:5px"
          :class="'pt_custom_social_' + index"
          v-model="selectedSocials[index].value"
          @change="()=>emit('setInputValue',{
            key: social.key,
            label: social.label,
            value: selectedSocials[index].value
          })"
          :placeholder="'@xyz123 *'"
          @blur="validateField({
            key: social.key,
            label: social.label,
            value: selectedSocials[index].value
          }, index)"
        />
        <span style="font-size: 14px; color: #DC0F1D;" v-if="error_social[social.key]" class="error_custom">{{ error_social[social.key] }}</span>
      </div>
    </div>
    <label style="font-size: 14px; color: #DC0F1D;" v-if="errorMessage" :for="id" class="error">{{ errorMessage }}</label>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  type: String, 
  options: Array,
  title: String,
  errorMessage: String || null,
  error_social: Object || null,
  
});
const emit = defineEmits(['checkOptions','setInputValue']);
const socialOptions = ref([]);
const selectedSocials = ref([]);
const errors = ref({});

onMounted(() => {
  if (props.options) {
    socialOptions.value = props.options;
    selectedSocials.value = socialOptions.value.map(() => ({
      checked: false,
      value: ''
    }));
  }
});

const toggleInputField = (e, index) => {
  emit('checkOptions', e);  
  props.errorMessage = null;
  if (props.error_social[e.key]) {
    props.error_social[e.key] = null;
  }
  if (!selectedSocials.value[index].checked) {
    selectedSocials.value[index].value = '';
  }
};

const validateField = (e, index) => {
  if (selectedSocials.value[index]) {
    const social = selectedSocials.value[index];
    if (social.checked && !social.value) {
      errors.value[index] = `Please enter your ${socialOptions.value[index].label} handle`;
    } else {
      errors.value[index] = null; 
      props.error_social[e.key] = null;
    }
  } else {
    delete errors.value[index];
    console.warn(`No social option found at index ${index}`);
  }
};

const validateForm = () => {
  errors.value = {};
  selectedSocials.value.forEach((social, index) => {
    if (social.checked && !social.value && social.isShowInput === 1) {
      errors.value[index] = `Please enter your ${socialOptions.value[index].label} handle`;
    }
  });
  return Object.keys(errors.value).length === 0;
};
</script>
